module.exports = __webpack_public_path__ + "assets/img/serviceA.a7d43f86.png";